//
import { localPreferences } from 'app-components/utils/core';

import { mkShareAcceptData } from './types';

const dataKey = 'share-accept-data';

export const getShareAcceptData = () => {
  const data = localPreferences.getItem(dataKey);
  return data ? mkShareAcceptData(data) : null;
};

export const setShareAcceptData = (data) => {
  localPreferences.setItem(dataKey, {
    granteeEmail: data.granteeEmail,
    isGranteeNewUser: data.isGranteeNewUser,
    datasetId: data.datasetId,
    used: data.used,
  });
};

export const removeShareAcceptData = () => {
  localPreferences.removeItem(dataKey);
};
